<template>
    <div class="compose-wrapper no-click">
        <div class="compose-window">
            <div class="header">
                <span class="is-white is-sanserif is-small-font is-bold">Compose Email</span>
                <i class="fas fa-times" @click="closeCompose()"></i>
            </div>
            <div class="body">
                <form class="compose-message">
                    <div class="input-wrapper">
                        <i class="fas fa-user-alt" />
                        <input type="text" name="to" placeholder="To:" class="input is-smaller-font is-dark-grey is-full-width is-sanserif" autocomplete="off">
                    </div><br>
                    <div class="input-wrapper">
                        <i class="fas fa-quote-left" />
                        <input type="text" name="subject" placeholder="Subject:" class="input is-smaller-font is-dark-grey is-full-width is-sanserif" autocomplete="off">
                    </div><br>
                    <Editor ref="editor" />
                    <button type="submit" class="button is-small is-success">Send</button>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
    import Editor from './Editor';
    export default {
        components: {
            Editor,
        },
        methods: {
            closeCompose() {
                if (confirm("Are you sure you want to discard this message?"))
                    document.querySelector('.compose-wrapper').classList.remove('open');
            }
        },
        mounted() {
            const composeWindow = document.querySelector('.compose-wrapper');
            const messageForm = document.querySelector('.compose-message');
            const toForm = composeWindow.querySelector('input[name=to]');
            const subjectForm = composeWindow.querySelector('input[name=subject]');
            const editor = this.$refs.editor.editor;

            new MutationObserver(() => {
                if (composeWindow.classList.contains('open'))
                    setTimeout(() => toForm.focus(), 50)
                else {
                    toForm.value = '';
                    subjectForm.value = '';
                    editor.clear.clearContent(true);
                }

            }).observe(composeWindow, { attributes: true });

            messageForm.onsubmit = async (evt) => {
                evt.preventDefault();

                const html = this.$refs.editor.html;

                if (!/\S+@\S+\.\S+/.test(toForm.value)) {
                    alert('Invalid recipient email');
                    return false;
                }

                if (subjectForm.value.length < 1)
                    if (!confirm("Subject is blank. Continue?"))
                        return false;

                console.log(editor, html);
                const response = await this.$gmail.messages.send(toForm.value, subjectForm.value, html);
                console.log(response);
                return false;
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "../assets/base";

    .compose-wrapper {
        .position(fixed,0,0,0,0);
        background-color:rgba(0,0,0,0.7);
        display: none;
        z-index: 1000000;

        &.open {
            display: block;
        }

        .compose-window {
            .position(fixed, 50%, unset, unset, 50%);
            transform: translate(-50%,-50%);
            width: 60vw;
            min-width: 400px;
            background-color: #fff;
            border-radius: @radius;

            .header {
                position: relative;
                border-radius:@radius @radius 0 0;
                background-color: @danger;
                padding: 5px;

                span {
                    display: block;
                    letter-spacing: 1px;
                    text-align: center;
                }

                i {
                    position: absolute;
                    top:50%;
                    right:30px;
                    transform: translateY(-50%);
                    color:rgba(255,255,255,0.5);
                    font-size: 18px;
                    transition: color 200ms linear;

                    &:hover {
                        color:rgba(255,255,255,0.8);
                    }
                }
            }

            .body {
                padding: 20px;
            }
        }
    }
</style>